var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 48,
    height: 48,
    rx: 14,
    fill: "#0F172A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 41C17 41 13 37.1 13 32.3C13 28.1 15.9 24.7 20 23.9C21.5 18.8 26.3 15.5 31.8 15.5C38.8 15.5 44.3 20.8 44.3 27.6C44.3 27.8 44.3 28 44.3 28.2C47.3 28.9 49.5 31.7 49.5 35C49.5 38.8 46.4 42 42.5 42H22Z",
    fill: "#E2E8F0",
    fillOpacity: 0.12,
    stroke: "#E2E8F0",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29 26L32 22L35 26",
    stroke: "#7DD3FC",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 22V36",
    stroke: "#7DD3FC",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.c7fa7a8d6cfe3d9c30682224cede641f.svg";
export { ForwardRef as ReactComponent };